import { Typography } from '@mui/material';
import { getGridSingleSelectOperators } from '@mui/x-data-grid';

/**
 * The "On tour" column of the Activities and Trip Items grids (CP-7921): whether the
 * record is on at least one tour. The backend sends `linked_to_group_tour` on the list
 * rows and filters on it server-side.
 *
 * A Yes / No single select rather than `type: 'boolean'`, whose filter offers
 * "any / true / false". The filter sends `{op: 'is', value: 'true' | 'false'}`
 * ('' or no value = any).
 */
export const ON_TOUR_FIELD = 'linked_to_group_tour';

export const onTourColumn = (overrides = {}) => ({
    field: ON_TOUR_FIELD,
    headerName: 'On tour',
    width: 96,
    sortable: false,
    type: 'singleSelect',
    valueOptions: [
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' },
    ],
    filterOperators: getGridSingleSelectOperators().filter((op) => op.value === 'is'),
    valueGetter: (p) => (p.row[ON_TOUR_FIELD] ? 'true' : 'false'),
    renderCell: (p) => (
        <Typography variant="body2" color={p.value === 'true' ? 'textPrimary' : 'textSecondary'}>
            {p.value === 'true' ? 'Yes' : 'No'}
        </Typography>
    ),
    ...overrides,
});

/** The mobile list's wording, matching the column. */
export const onTourLabel = (row) => (row[ON_TOUR_FIELD] ? 'On tour' : 'Not on tour');
